import type { AxiosError, AxiosResponse } from "axios";
import type {
  EscalateTicketData,
  EscalateTicketInput,
  EscalationHistoryItem,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

// POST /servicedesk/ticket/{ticket_id}/escalate/
// Path is singular `escalate` with TRAILING SLASH — verified by Bastian (API_CONTRACT.md §1).
export const escalateTicket = async (
  ticketId: string,
  payload: EscalateTicketInput,
): Promise<EscalateTicketData> => {
  try {
    const response = await axiosClient.post(
      `/servicedesk/ticket/${ticketId}/escalate/`,
      payload,
    );
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: unknown) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};

// GET /servicedesk/ticket/{ticket_id}/escalations
// Path is plural `escalations` with NO trailing slash — verified by Bastian (API_CONTRACT.md §2).
// Returns the full escalation history, newest first (backend sort order is reliable).
export const getTicketEscalations = async (
  ticketId: string,
): Promise<EscalationHistoryItem[]> => {
  try {
    const response = await axiosClient.get(
      `/servicedesk/ticket/${ticketId}/escalations`,
    );
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: unknown) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};
